/**
 * Nomes de permissões usados nas verificações do frontend.
 * Devem ser idênticos aos cadastrados na tabela `permissions` do backend.
 */
export const PERMISSIONS = {
  /** Painel de correção manual de balanços (grupo "Configurações do Sistema"). */
  MANAGE_BALANCE_ADJUSTMENTS: "manage-balance-adjustments",

  /** Tela de acesso como usuário / personificação (grupo "Configurações do Sistema"). */
  IMPERSONATE_USERS: "impersonate-users",

  /** Normalização de vendas inconsistentes (grupo "Configurações do Sistema"). */
  MANAGE_SALE_NORMALIZATION: "manage-sale-normalization",

  /** Enviar e remover comprovantes de devolução (grupo "Devoluções"). */
  UPLOAD_DEVOLUTION_RECEIPT: "upload-devolution-receipt",

  /** Sangrias (grupo "Sangrias"). */
  VIEW_BLEED_LIST: "view-bleed-list",
  CREATE_BLEED: "create-bleed",
  VIEW_ALL_BLEEDS: "view-all-bleeds",
  APPROVE_BLEED: "approve-bleed",
  REJECT_BLEED: "reject-bleed",
  /** Tela de logs de ações de concursos e vendas (grupo "Configurações do Sistema"). */
  VIEW_ACTION_LOGS: "view-action-logs",
  /**
   * Aba "Resultado Clientes" com todos os vendedores (grupo "Vendas").
   * Vendedor acessa sempre e vê só as próprias vendas (regra também na API).
   */
  VIEW_CLIENT_RESULTS: "view-client-results",

  /** Recebe os alertas de % de estoque (grupo "Estoque"). LOT-26 */
  RECEIVE_STOCK_ALERTS: "receive-stock-alerts",

  /** Aba "Premiações Totais": premiações apuradas por concurso (grupo de "Lista de Prêmios"). */
  VIEW_TOTAL_PRIZES: "view-total-prizes",

  /** Gerar relatório "Compras Clientes" (tela Gerar Relatório). */
  VIEW_CUSTOMER_PURCHASES_REPORT: "view-customer-purchases-report",
} as const;
